var _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2241 15.1508L10.0922 15.633H10.0922L10.2241 15.1508ZM10.4663 15.217L10.5982 14.7347H10.5982L10.4663 15.217ZM13.5315 15.2073L13.3966 14.7258L13.5315 15.2073ZM14.1096 15.0452L14.2446 15.5267L14.1096 15.0452ZM10.0922 15.633L10.3344 15.6993L10.5982 14.7347L10.356 14.6685L10.0922 15.633ZM13.6665 15.6887L14.2446 15.5267L13.9746 14.5638L13.3966 14.7258L13.6665 15.6887ZM10.3344 15.6993C11.4255 15.9977 12.5773 15.9941 13.6665 15.6887L13.3966 14.7258C12.4818 14.9823 11.5146 14.9853 10.5982 14.7347L10.3344 15.6993ZM19.3177 18.8451C19.4722 15.9651 16.7517 13.7853 13.9746 14.5638L14.2446 15.5267C16.3623 14.933 18.4369 16.5953 18.3192 18.7916L19.3177 18.8451ZM6.13023 19.1931C5.76264 16.9185 7.8697 15.0252 10.0922 15.633L10.356 14.6685C7.43175 13.8687 4.65938 16.3599 5.14303 19.3527L6.13023 19.1931Z",
    fill: "#0E0333"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9107,
    cy: 9.30425,
    r: 3.16754,
    stroke: "#0E0333"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9.5,
    stroke: "#0E0333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.779d75c389a3be6f696cc9ac4e9d7f0a.svg";
export { ForwardRef as ReactComponent };